import type { UseFormSetError } from "react-hook-form";
import type { CountryFeatures } from "types/countryFeatures";
import type { TFormCreateBeneficiar } from "./types";

type SetError = UseFormSetError<TFormCreateBeneficiar>;
type TFunction = (key: string, options?: Record<string, unknown>) => string;

export function validateBankingMetadata(
    bankingMeta: Record<string, string>,
    countryFeatures: CountryFeatures,
    setError: SetError,
    t: TFunction,
): boolean {
    const rules = countryFeatures.validation.bankingFields;
    const metadataFields = countryFeatures.bankingFields.filter((f) => f !== "iban" && f !== "bic");
    let hasErrors = false;
    for (const fieldKey of metadataFields) {
        const fieldRules = rules?.[fieldKey as keyof typeof rules];
        if (!fieldRules) continue;
        const value = (bankingMeta[fieldKey] ?? "").replace(/[\s-]/g, "");
        if (!value) continue;
        if ("length" in fieldRules && fieldRules.length != null) {
            if (value.length !== fieldRules.length) {
                setError(`bankingMetadata.${fieldKey}` as Parameters<SetError>[0], {
                    message: t("Settings.BankFieldExactLength", {
                        field: t(`Beneficiary.${fieldKey}`),
                        count: fieldRules.length,
                    }),
                });
                hasErrors = true;
            }
        } else {
            const min = (fieldRules as { minLength?: number }).minLength;
            const max = (fieldRules as { maxLength?: number }).maxLength;
            if ((min != null && value.length < min) || (max != null && value.length > max)) {
                setError(`bankingMetadata.${fieldKey}` as Parameters<SetError>[0], {
                    message: t("Settings.BankFieldLengthRange", {
                        field: t(`Beneficiary.${fieldKey}`),
                        min,
                        max,
                    }),
                });
                hasErrors = true;
            }
        }
    }
    return hasErrors;
}
